import chroma from 'chroma-js'

function calculateIntervalColors(
  valueRange: number[],
  colorRange: string[],
  steps: number
) {
  return {
    interval: calculateInterval(valueRange, steps),
    colorScale: calculateColorScale(colorRange, steps)
  }
}

function calculateColorScale(colorRange: string[], steps: number) {
  return colorRange.length > 3
    ? colorRange
    : chroma.scale(colorRange).colors(steps) // TODO: steps + 1
}

function calculateInterval(valueRange: number[], steps: number) {
  const start = valueRange[0]
  const end = valueRange[1]
  const diff = Math.round(end - start)
  let increment = diff / steps
  increment = Math.round((increment + Number.EPSILON) * 100) / 100
  const interval = []
  for (let i = start; i <= end; i += increment) {
    interval.push(i)
  }
  return interval
}

let opacity = 0.5
function setOpacity(newOpacity: number) {
  opacity = newOpacity
}

function automaticStyleDiscreteValues(
  interval: number[],
  colorScale: string[]
) {
  return (feature: any) => {
    // const opacity = store.getters['app/opacity']

    // const props = feature.properties ? feature.properties[0] : feature
    // let level = props ? props.DN : feature.properties.DN
    // const color = automatedColor(level, interval, colorScale)
    const props = feature.properties || feature
    const color = getColor(props, interval, colorScale)

    return {
      stroke: false,
      fill: true,
      fillColor: color,
      weight: 0.5,
      opacity: opacity,
      color: '',
      dashArray: '0',
      fillOpacity: opacity
    }
  }
}

function automaticStyleBinary() {
  // colorScale: string[]
  return (feature: any) => {
    // const opacity = store.getters['app/opacity']
    const props = feature.properties ? feature.properties[0] : feature
    const level = props ? props.ID : feature.properties.ID

    let color = '#ffffff00'
    if (level !== 0) {
      color = '#ff0000'
    }
    return {
      stroke: false,
      fill: true,
      fillColor: color,
      weight: 0.5,
      opacity: opacity,
      color: '',
      dashArray: '0',
      fillOpacity: opacity
    }
  }
}

function automaticStyle(
  interval: number[],
  colorScale: string[],
  outRangeMin: boolean,
  outRangeMax: boolean
): L.StyleFunction {
  return function (feature: any) {
    // const opacity = store.getters['app/opacity']

    // const props = feature.properties ? feature.properties[0] : feature
    const props = feature.properties || feature
    const color = getColor(
      props,
      interval,
      colorScale,
      outRangeMin,
      outRangeMax
    )

    return {
      stroke: false,
      fill: true,
      fillColor: color,
      weight: 0.5,
      opacity: opacity,
      color: '',
      dashArray: '0',
      fillOpacity: opacity
    }
  }
}

function getColor(
  props: any,
  interval: number[],
  colorScale: string[],
  outRangeMin = false,
  outRangeMax = false
) {
  const lowerValue = props.lowerValue
  const upperValue = props.upperValue
  const dn = props.DN

  let value = null
  if (lowerValue !== undefined && upperValue !== undefined) {
    const lvIndex = interval.indexOf(lowerValue)
    const uvIndex = interval.indexOf(upperValue)
    const diffIndex = uvIndex - lvIndex

    // Apaño para gdal_contour que se salta intervalos cuando no hay valores
    value = lowerValue
    if (diffIndex > 1 || uvIndex === 0 || upperValue < lowerValue) {
      let newValueIndex = getIntervalIndex(interval, upperValue)

      if (newValueIndex > 0) {
        newValueIndex = newValueIndex - 1
      }

      value = interval[newValueIndex]
    }
  } else if (dn !== undefined) {
    value = dn
  } else {
    console.error('Unknown properties', props, interval, colorScale)
  }

  return automatedColor(value, interval, colorScale, outRangeMin, outRangeMax)
}

function getIntervalIndex(interval: number[], value: number) {
  let index = 0
  const indexFound = interval.indexOf(value)
  if (indexFound >= 0) {
    index = indexFound
  } else {
    for (let i = interval.length - 1; i >= 0; i--) {
      if (value >= interval[i]) {
        index = i
        break
      }
    }
  }
  return index
}

function automatedColor(
  value: number,
  interval: number[],
  colorScale: string[],
  outRangeMin: boolean,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  outRangeMax: boolean
) {
  let index = getIntervalIndex(interval, value)

  if (outRangeMin) {
    //  || outRangeMax
    index = index + 1
  }

  if (!outRangeMin && !outRangeMax && index >= colorScale.length) {
    index = colorScale.length - 1
  }
  const color = colorScale[index]
  return color
}

export default {
  calculateIntervalColors: calculateIntervalColors,
  calculateColorScale: calculateColorScale,
  calculateInterval: calculateInterval,
  setOpacity: setOpacity,
  automaticStyle: automaticStyle,
  automaticStyleDiscreteValues: automaticStyleDiscreteValues,
  automaticStyleBinary: automaticStyleBinary,

  getColor: getColor
}
